var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-card-title",
                [
                  _c("h3", { staticClass: "headline mb-0 admin-header" }, [
                    _vm._v("Drivers"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "", color: "grey lighten-1" },
                      on: { click: _vm.refresh },
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "fal fa-search",
                      placeholder: "Search",
                      "single-line": "",
                      "hide-details": "",
                      clearable: "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  items: _vm.collectordrivers,
                  "item-key": "id",
                  search: _vm.search,
                  loading: _vm.loading,
                  headers: _vm.headers,
                  options: _vm.pagination,
                },
                on: {
                  "update:options": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.schedule.lastRunTime",
                    fn: function ({ item }) {
                      return [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              item.schedule &&
                                _vm.formatTimeValue(item.schedule.lastRunTime)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.schedule.nextRunTime",
                    fn: function ({ item }) {
                      return [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              item.schedule &&
                                _vm.formatTimeValue(item.schedule.nextRunTime)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.buildInfo.git.build.time",
                    fn: function ({ item }) {
                      return [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.formatTimeValue(
                                item.buildInfo["git.build.time"]
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.buildInfo.git.commit.id.abbrev",
                    fn: function ({ item }) {
                      return [
                        _c("td", [
                          _vm._v(
                            _vm._s(item.buildInfo["git.commit.id.abbrev"])
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }